<template>
    <div class="inner-wrapper add-customer-section">
   <!--<div class="page-title">
      <h1 class="float-left">Add Vendor</h1>
   </div>-->
   <ValidationObserver v-slot="{ handleSubmit }">
   <form @submit.prevent="save" id="addCustomerForm" name="addCustomerForm" method="post">
      <div class="new-rfq">
        <div class="row">
            <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                <strong class="success_msg">{{successMessage}}</strong>
            </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-12 col-md-12">
                <div class="card panel create-box  mb-3">


<div class="container my-4">

  <div class="section-box">
    <h2 class="mb-3 inner-title">Company Information</h2>
    <div class="row g-4">

      <!-- Left column -->
      <div class="col-md-3">
        <div class="mb-3">
          <label class="form-label">Company Name</label>
          <validation-provider rules="required" v-slot="{ errors }">
            
            <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
            <span class="error">{{ errors[0] }}</span>
        </validation-provider>
        </div>

        <div class="mb-3">
          <label class="form-label">Country</label>
          <validation-provider rules="required" v-slot="{ errors }">
           
            <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                <option value="null">Select Country</option>
                <option v-for="country in countries" :value="country.id">{{country.name}}</option>
            </select>
            <span class="error">{{ errors[0] }}</span>
        </validation-provider>
        </div>

        <div class="mb-3">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
        </div>

        <!-- <div class="mb-3">
          <label class="form-label">Fax</label>
          <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
        </div> -->

      </div>

      


      <!-- Middle column -->
      <div class="col-md-4">
      <div class="form-group flex-fill">
       

        <validation-provider rules="required" v-slot="{ errors }">
            <label class="form-label">Company Address</label>
            <textarea class="form-control address-box" style="height:201px"  v-model="form.address" rows="12"></textarea>
            <span class="error">{{ errors[0] }}</span>
        </validation-provider>

       
        
      </div>
        

        
      </div>

      <!-- Right column -->
      <div class="col-md-5">
        <label class="form-label">Sample Address</label>

        

        
        <textarea class="form-control address-box" v-model="form.sample_address" style="height:201px" rows="12"></textarea>
      </div>

    </div>
  </div>

</div>

                    <!-- <div class="card-body pb-0">
                        <h2 class="mb-3 inner-title">Company Information</h2>
                        
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group flex-fill">
                                    <label>Company Name</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                        <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
                                        <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group flex-fill">
                                    

                                    <GooglePlaceAutoCompleteSingle v-if="loadMap"
                                    :title="'Company Address'"
                                    :placeholder="'Company Address'"
                                    :errors="null"
                                    v-model="form.address"
                                    @selectedEvent="selectCompanyAddress"></GooglePlaceAutoCompleteSingle>

                                   
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group flex-fill">
                                    <label>Country</label>
                                    <validation-provider rules="required" v-slot="{ errors }">
                                    <select class="form-control" id="country_id" name="country_id" v-model="form.country_id">
                                        <option value="null">Select Country</option>
                                        <option v-for="country in countries" :value="country.id">{{country.name}}</option>
                                    </select>
                                    <span class="error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group flex-fill">
                                    <label>Website</label>
                                    <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <div class="form-group flex-fill">
                                    <label>Fax</label>
                                    <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
        <div class="card panel  mb-3">
            <div class="card-body pb-0">
            <div class="add-container">
                <h2 class="inner-title">Contact</h2>
                    <div class="product-create">
                    <div id="email_alert" class="alert alert-danger" style="display: none;">
                        <strong>Please fill out * fields</strong>
                    </div>
                <div class="btn btn-info plus-icon dff-pos"  @click="addNewContact()" alt="plus-icon" ><i  class="ri-add-circle-line align-middle"></i>  Add New</div>
                <div class="add_new_contact">
                    <template v-for="(contact, index) in form.contacts">
                        <div class="contact-dtlbox">
                            <div class="row count_contact contact_1">
                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="contact_name" class="control-label">Full Name </label>
                                        <validation-provider rules="required" v-slot="{ errors }">
                                        <input type="text" class="form-control" id="contact_name" name="contact_name" v-model="contact.contact_name">
                                            <span class="error">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="contact_email" class="control-label">Email </label>
                                        <validation-provider rules="required" v-slot="{ errors }">
                                        <input type="email" class="form-control" id="contact_email" name="contact_email" v-model="contact.contact_email">
                                        <span class="error">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </div>
                                </div>
                                <template v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-if="contactIndex == 0">
                                        <div class="form-group cmbne-sel-inpt">
                                            <label>&nbsp;</label>
                                            <div class="add-contact">
                                            <validation-provider rules="required" v-slot="{ errors }">
                                                <select class="form-control select-control" name="contact_phn_type" v-model="contact_number.contact_phn_type">
                                                    <option value="Mobile">Mobile</option>
                                                    <option value="Office">Office</option>
                                                </select>
                                                    <span class="error">{{ errors[0] }}</span>
                                                </validation-provider>
                                                <validation-provider rules="required" v-slot="{ errors }">
                                                <input type="text" class="form-control contact_no"  name="contact_phone_no" v-model="contact_number.contact_phone_no"/>
                                                <span class="error">{{ errors[0] }}</span>
                                                </validation-provider>
                                                <div class="action-btn">
                                                    <div v-if="contactIndex == 0" class="plus-icon" @click="addNewNumber(index)" alt="plus-icon" ><i class="ri-add-circle-line"></i></div>
                                                    <a v-if="contactIndex > 0" class="btn btn-danger remove mt-1"  @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" >Remove</a>
                                                </div>

                                            </div>
                                            <div class="action-btn-row">
                                                    <a v-if="index > 0" class="btn btn-danger remove mt-1" @click="removeContact(index)"  href="javascript:void(0);" >Remove</a>
                                                </div>
                                            <!--<div class="action-btn">
                                                <a v-if="contactIndex > 0" class="minus-icon2"  @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" ><i class="fas fa-minus-circle" ></i> t</a>
                                                <a v-if="index > 0" class="remove-icon" @click="removeContact(index)"  href="javascript:void(0);" ><i class="fas fa-trash-alt"></i>s</a>
                                            </div>-->
                                        </div>

                                    </div>

                                </template>


                            </div>

                            <div class="row contact_row_1 number_row">
                                <template v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                    <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-if="contactIndex> 0">
                                        <div class="form-group cmbne-sel-inpt">
                                            <div class="add-contact">
                                                <validation-provider rules="required" v-slot="{ errors }">
                                                    <select class="form-control select-control" name="contact_phn_type" v-model="contact_number.contact_phn_type">
                                                        <option value="Mobile">Mobile</option>
                                                        <option value="Office">Office</option>
                                                    </select>
                                                <span class="error">{{ errors[0] }}</span>
                                                </validation-provider>
                                                <validation-provider rules="required" v-slot="{ errors }">
                                                <input type="text" class="form-control contact_no"  name="contact_phone_no" v-model="contact_number.contact_phone_no"/>
                                                <span class="error">{{ errors[0] }}</span>
                                                </validation-provider>
                                                <div class="action-btn">
                                                    <div v-if="contactIndex == 0" class="plus-icon" @click="addNewNumber(index)" alt="plus-icon" ><i class="fas fa-plus"></i></div>
                                                    <a v-if="contactIndex > 0" class="minus-icon btn btn-danger" @click="removeNumber(index, contactIndex)"  href="javascript:void(0);" ><i class="ri-delete-bin-6-line"></i></a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </template>
                            </div>
                        <!-- <div class="row contact_row_1 number_row">
                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label for="status" class="mdl-textfield__label">Status </label>
                                    <select class="form-control mdl-textfield__input" id="status" name="status" v-model="contact.status">
                                        <option value="1">Active</option>
                                        <option value="2">InActive</option>
                                    </select>
                                </div>
                            </div>
                        </div> -->

                        </div>
                    </template>

                </div>
                </div>
                </div>
                </div>
            </div>

            <div class="row ">
                <div class="col-lg-12 col-md-12">
                    <div class="card panel  mb-3">

                        <div class="card-body pb-0">
                            <!--<h2  class="inner-title">Terms of Vendor </h2>-->
                            <form>
                                <div class="form-group">
                                <label>Terms of Vendor </label>
                                <textarea rows="4" class="form-control" v-model="form.vendor_terms" placeholder=""></textarea>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row ">
                <div class="col-lg-12 col-md-12">
                    <div class="card panel  mb-3">
                        <div class="card-body pb-0">
                            <div class="row ">
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group">
                                <label for="status" class="mdl-textfield__label">Found them</label>
                                <!-- <input type="text" class="form-control" v-model="form.found_them" > -->
                                <v-select label="found_them" taggable  placeholder="Select Found them"    v-model="form.found_them" :filterable="true" :options="optionsFound" :reduce="(option) => option.found_them">
                                    <template slot="no-options">
                                    Search
                                    </template>
                                    <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.found_them }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.found_them }}
                                    </div>
                                    </template>
                                </v-select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group">
                                    <label for="status" class="mdl-textfield__label">Doing Exports?</label>
                                    <input type="text" class="form-control mdl-textfield__input" id="doing_exports" name="doing_exports" v-model="form.doing_exports">

                                </div>
                            </div>
                            <div class="col-lg-3 col-md-3">
                                <div class="form-group">
                                    <label for="status" class="mdl-textfield__label">Vendor Business</label>
                                <v-select label="bag_name" placeholder="Select Vendor Business" multiple v-model="form.vendor_bag" :filterable="true" :options="options" :reduce="(option) => option.id" >
                                        <template slot="no-options">
                                        Search
                                        </template>
                                        <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.bag_name }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.bag_name }}
                                        </div>
                                        </template>
                                    </v-select>
                                    </div>
                            </div>

                            <div class="col-lg-3 col-md-3">
                                    <div class="form-group">
                                        <label for="status" class="mdl-textfield__label2">Status *</label>
                                        <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                            <option value="1">Active</option>
                                            <option value="2">InActive</option>
                                            <option value="3">New Vendor</option>
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="card panel  mb-3">

                        <div class="card-body">
                            <!-- <h2  class="inner-title"> Other </h2> -->
                            <div class="row">
                                <div class="col-lg-6 col-md-6">
                                    <form>
                                        <div class="form-group">
                                        <label>About the Vendor</label>
                                        <textarea rows="4" class="form-control address-box" style="height:117px" v-model="form.aboutv" placeholder=""></textarea>
                                        </div>
                                    </form>
                                    <template v-for="(aboutVendor, aboutIndex) in form.about_vendor">
                                        <div class="form-group">

                                            <textarea rows="4" class="form-control" v-model="aboutVendor.description" placeholder=""></textarea>
                                        </div>
                                    </template>
                                </div>
                                
                                <div class="col-lg-6 col-md-6">
                                    <div  v-cloak @drop.prevent="addFile" @dragover.prevent class="files task-files">
                                <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file" style="border: none;">
                                    <h2>Files to Upload (Drag them over)</h2>

                                    <ul>
                                        <li v-for="file in form.files">
                                        {{ file.name }}  <button @click="removeFile(file)" title="Remove">X</button>
                                        </li>
                                    </ul>


                                </div>
                                </div>

                            </div>

                            


                        </div>
                    </div>
                </div>


            </div>

            <!-- <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="card panel  mb-3">

                        <div class="card-body">
                            <div class="form-group-up">
                                <div  v-cloak @drop.prevent="addFile" @dragover.prevent class="files task-files">
                                <input type="file" name="csv_file" v-on:change="handleFileUpload" ref="csv_file" style="border: none;">
                                    <h2>Files to Upload (Drag them over)</h2>

                                    <ul>
                                        <li v-for="file in form.files">
                                        {{ file.name }}  <button @click="removeFile(file)" title="Remove">X</button>
                                        </li>
                                    </ul>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->




            </div>
        </div>


            <div class="btnrow text-right mb-2">
                <router-link :to="{name: 'viewVendors'}" class="btn btn-danger me-1">Discard</router-link>
                <button type="submit" class="btn btn-primary" id="save_customer_btn">Save</button>
                <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
            </div>
      </div>
   </form>
</ValidationObserver>
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import GooglePlaceAutoCompleteSingle from "../../components/GooglePlaceAutoCompleteSingle";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "VendorEdit",
    components: {
        ValidationProvider,ValidationObserver,GooglePlaceAutoCompleteSingle
    },
    created() {
        this.getCustomer();
        this.getCountries();
        this.getVendorBag();
        this.getFoundThem();
    },
    mounted() {
        this.loadMap = true;
    },
    data(){
        return {
            loadMap : false,
            selected:[],
            options:[],
            optionsFound:[],
            taskPriority:[],
            inlineDatePicker:true,
            autoApply:false,
            singleDatePicker:true,
            showDropdowns:true,
            countries: [],
            form: {
                sample_address:null,
                vendor_bag:[],
                files:[],
                selected:[],
                id: null,
                company_name: null,
                address: '',
                country_id: null,
                found_them:'',
                website: '',
                fax: '',
                aboutv:'',
                vendor_terms:'',
                about_vendor:[],
                contacts: [
                    {
                        contact_id: null,
                        contact_name: '',
                        contact_email: '',
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                about_us: '',
                status: 1,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomerLoading'
        ]),
        selectCompanyAddress(place){
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            if(place.name != '') {
                this.form.address = place.formatted_address;
            }
            else{
                this.form.address = place.formatted_address;
            }
        },
        getVendorBag() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getVendorBag'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.options = data.data.data;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getFoundThem() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getFoundThem'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                       // self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                       // self.setErrorMessage(data.errorMessage);
                    } else {
                        this.optionsFound = data.data.data;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getCustomer() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('vendors.show', {id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        console.log("this.customerData 11",data);

                        let contacts = []; //window._.cloneDeep(data.data.customer_contact);

                        data.data.vendor_contact.forEach((value, index) => {
                            console.log("series data check",value.contact_id);
                            let contactNumbers = [];
                            let i =0;
                            if(value.mobile_numbers){
                                value.mobile_numbers.forEach((mobile, mobileIndex) => {
                                    contactNumbers[i] = {
                                        contact_phn_type: 'Mobile',
                                        contact_phone_no: mobile,
                                    }
                                    i++;
                                    console.log("Mobile ",mobile);
                                });
                            }
                            else{
                                contactNumbers[i] = {
                                    contact_phn_type: 'Mobile',
                                    contact_phone_no: null,
                                }
                            }
                            if(value.office_numbers){
                                value.office_numbers.forEach((office, officeIndex) => {
                                    contactNumbers[i] = {
                                        contact_phn_type: 'Office',
                                        contact_phone_no: office,
                                    }
                                    i++;
                                    console.log("Mobile ",office);
                                });
                            }
                            else{
                                contactNumbers[i] = {
                                    contact_phn_type: 'Office',
                                    contact_phone_no: null,
                                }
                            }
                            contacts[index] = {
                               contact_id: value.contact_id,
                                contact_name: value.contact_name,
                                contact_email: value.contact_email,
                                contact_status: value.contact_status,
                                default_contact: value.default_contact,
                                contact_role: value.contact_role,
                                contact_numbers:contactNumbers
                            };
                        });

                        this.form.id = data.data.vendor.id;
                        this.form.status = data.data.vendor.status;
                        this.form.about_us = data.data.vendor.about_us;
                         this.form.aboutv = data.data.vendor.about_us;
                        this.form.fax = data.data.vendor.fax;
                        this.form.website = data.data.vendor.website;
                        this.form.country_id = data.data.vendor.country_id;
                        this.form.address = data.data.vendor.address;
                        this.form.company_name = data.data.vendor.company_name;
                        this.form.sample_address = data.data.vendor.sample_address;
                        this.form.found_them = data.data.vendor.found_them;
                        this.form.vendor_terms = data.data.vendor.vendor_terms;
                        this.form.contacts = contacts;
                        this.form.about_vendor = data.data.about_vendor;
                        let vendorBagsId = [];
                        let vendorBags = [];
                        if(data.data.vendor_bags.length > 0){
                            data.data.vendor_bags.forEach((userValue, userIndex) => {

                                vendorBagsId[userIndex] = userValue.bag_id;
                                vendorBags[userIndex] = {id:userValue.bag_id,bag_name:userValue.bag_name}
                            });

                         }
                        console.log("array created ",vendorBags);
                        this.options = vendorBags;
                        this.form.vendor_bag = vendorBagsId;
                        console.log("data  now",this.form.contacts);
                        console.log("data  now",this.form);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addFile(e) {
            let droppedFiles = e.dataTransfer.files;
            if(!droppedFiles) return;
            // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
            ([...droppedFiles]).forEach(f => {
                this.form.files.push(f);
            });
            console.log("files ",this.form.files);
        },
        removeFile(file){
            this.form.files = this.form.files.filter(f => {
                return f != file;
            });
        },
        handleFileUpload(){
            this.form.files.push(this.$refs.csv_file.files[0]);
            //this.csv_file = this.$refs.csv_file.files[0];
        },
        onSearch(search, loading) {
            if(search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            return axios.post(window.route('searchVendorsBag',{searchTerm: search,selected_vendor:this.form.vendor_bag} ), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log("DATA ",data);
                if(data.errors){
                    console.log("error ",data);
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {
                    console.log("Length",data);

                    let allData =  data.data.data
                    console.log("Vendor Bags",allData);
                    for (var i = 0; i < data.data.data.length; i++)
                    {
                          vm.options.push({id:allData[i].id,bag_name:allData[i].bag_name});

                    }

                    console.log('this.form.vendor_bag',this.form.vendor_bag);
                    //vm.options.push(data.data.data);

                   loading(false);

                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });
        },
        save() {

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            let formData = new FormData();
            if(this.form.files){
                this.form.files.forEach((f,x) => {
                formData.append('file[]', f);
            });
            }

            formData.append('company_name', this.form.company_name);
            formData.append("_method", "PUT")
            formData.append('address', this.form.address);
            formData.append('sample_address', this.form.sample_address);
            formData.append('country_id', this.form.country_id);
            formData.append('website', this.form.website);
            formData.append('fax', this.form.fax);
            // this.form.contacts.forEach((f,x) => {
            //     //this.form.locations.forEach((location, i) => form.append(`locations[${i}]`, location));
            //     formData.append(`contacts[${x}]`, f);
            // });
            //JSON.stringify(game)
            formData.append('contacts', JSON.stringify(this.form.contacts));
            formData.append('vendor_terms', this.form.vendor_terms);
            formData.append('found_them', this.form.found_them);
            formData.append('doing_exports', this.form.doing_exports);
             this.form.vendor_bag.forEach((f,x) => {
                formData.append('vendor_bag[]', f);
            });

           // formData.append('vendor_bag', this.form.vendor_bag);
            formData.append('aboutv', this.form.aboutv);
            formData.append('status', this.form.status);
            formData.append('about_vendor', JSON.stringify(this.form.about_vendor) );
            return axios.post(window.route('vendors.update', {id: this.$route.params.id}), formData,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                },
                headers: {
                        'Content-Type': 'multipart/form-data'
                },
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendorData = data.data;
                        console.log(data);
                        this.form =  {
                            id: null,
                            company_name: null,
                            address: null,
                            country_id: null,
                            website: null,
                            fax: null,
                            contacts: [
                                {
                                    contact_id: null,
                                    contact_name: null,
                                    contact_email: null,
                                    contact_numbers: [
                                        {
                                            contact_phn_type: 'Mobile',
                                            contact_phone_no: null,
                                        }
                                    ]
                                }
                            ],
                            about_us: null,
                            status: 1,
                        };
                        self.$router.push({ name: 'viewVendors' });

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addNewContact() {
            this.form.contacts.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

            console.log(this.form.contacts.length);

        },
        removeContact(index){
            this.form.contacts.splice(index, 1);
        },
        addNewNumber(index) {
            this.form.contacts[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
        },
        removeNumber(index, contactIndex) {
            this.form.contacts[index].contact_numbers.splice(contactIndex, 1);
        },
        getCountries() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('countries.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.countries = data.data.countries;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
